import React, { useState, useEffect } from 'react';
import VisibilityIcon from '@/Icons/VisibilityIcon';
import VisibilityOffIcon from '@/Icons/VisibilityOffIcon';
import withDisableAutofill from '@/Helpers/withDisableAutofill';


const TextField = ({
    label,
    type,
    onChange,
    togglePassword,
    placeHolder,
    value = '',
    className,
    helperText,
    error,
    startIcon,
    size,
    hasClearIcon,
    ...props
}) => {
    const [visibility, setVisibility] = useState(false);
    const [txtFieldType, setTxtFieldType] = useState(type);
    const [passwordClass, setPasswordClass] = useState(false);

    useEffect(() => {
        if (type === 'password') {
            setPasswordClass(true);
        }
    }, [type]);

    useEffect(() => {
        if (togglePassword && (txtFieldType === 'password' || txtFieldType === 'text')) {
            if (txtFieldType === 'password' && visibility) {
                setTxtFieldType('text');
            } else if (txtFieldType === 'text' && !visibility) {
                setTxtFieldType('password');
            }
        } else {
            setTxtFieldType(txtFieldType);
        }
    }, [visibility, togglePassword, txtFieldType]);

    const handleOnChange = (e) => {


        if (togglePassword && value.length === 0) {
            setVisibility(false);
        }

        if (onChange && typeof onChange === 'function') {
            onChange(e);
        }
    };

    const handleClearIconClick = () => {
        if (onChange && typeof onChange === 'function') {

            const { name } = props;

            const e = {
                target: {
                    value: '',
                    name : name
                }
            }

            onChange(e);
        }
    };

    const renderStartIcon = () => {
        return (
            <div className={`${props.disabled ? 'start-icons-disabled' : 'start-icons'}`}>
                <span className="start-icon">{startIcon}</span>
            </div>
        );
    };

    const renderEndIcons = () => {
        if ((togglePassword &&
            (txtFieldType === 'password' || txtFieldType === 'text'))
        ) {
            return (
                <div className={`end-icons ${props.disabled ? 'bg-disabled' : ''}`}>
                    {togglePassword && renderShowPasswordIcon()}
                </div>
            );
        }

        if (hasClearIcon && value?.length > 0) {
            return (
                <div onClick={() => handleClearIconClick()} className={`end-icons cursor-pointer`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className='svg-regular' viewBox="0 0 24 24" fill="none">
                        <mask id="mask0_829_4757" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                            <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_829_4757)">
                            <path d="M7.2 18L6 16.8L10.8 12L6 7.2L7.2 6L12 10.8L16.8 6L18 7.2L13.2 12L18 16.8L16.8 18L12 13.2L7.2 18Z" fill="#5B61A1" />
                        </g>
                    </svg>
                </div>

            )
        }
    };

    const renderShowPasswordIcon = () => {
        return (
            <span className={`password-icon ${props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={handleOnClick}>
                {visibility && <VisibilityIcon />}
                {!visibility && <VisibilityOffIcon />}
            </span>
        );
    };

    const handleOnClick = () => {
        if (props.disabled === false) {
            setVisibility(!visibility);
        }

    };

    return (
        <div className={`textfield w-full ${passwordClass ? 'input-password' : ''}`}>
            {label && (
                <div className='textfield-label'>
                    <label>{label}</label>
                </div>
            )}
            <div className={`textfield-group ${error ? 'textfield-group-border-error' : ''} ${props.disabled ? 'bg-disabled border-0' : ''} ${size === 'sm' ? '!h-10' : ''}`}>
                {startIcon && renderStartIcon()}
                <input
                    placeholder={placeHolder}
                    autoComplete="off"
                    type={togglePassword ? txtFieldType : type}
                    className={`textfield-input ${startIcon ? 'textfield-input-start' : ''} ${togglePassword ? 'pr-0' : ''} ${className ? className : ''} ${error ? 'error' : ''}`}
                    onChange={handleOnChange}
                    value={value}
                    {...props}
                />
                {renderEndIcons()}
            </div>
            {(error || helperText) && <div className='flex w-full mt-2 items-center text-12'>

                {helperText && <span className={`textfield-helper-text ${error ? 'text-red' : 'text-black'} `}>
                    {helperText}
                </span>}
            </div>}
        </div>
    );
};

TextField.defaultProps = {
    type: 'text',
}

export default withDisableAutofill(TextField);